import { render, staticRenderFns } from "./exportTips.vue?vue&type=template&id=025d6740"
import script from "./exportTips.vue?vue&type=script&lang=js"
export * from "./exportTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports